import { Link } from '@remix-run/react'
import { Card, CardBody } from 'reactstrap'

import logo from '../../public/images/logo.svg'

export default function AuthCard({
  children,
  title,
  subtitle,
  backgroundImage,
}: {
  children: React.ReactNode
  title?: string
  subtitle?: string
  backgroundImage: string
}) {
  return (
    <>
      <Card className="overflow-hidden">
        <div
          className="bg-image"
          style={{
            minHeight: '110px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundImage: `url(${backgroundImage})`,
          }}
        ></div>
        <CardBody className="pt-0">
          <div>
            <Link to="/" className="logo-dark-element">
              <div className="avatar-lg profile-user-wid mb-4">
                <span className="avatar-title rounded-circle bg-light">
                  <img src={logo} alt="Clube do Tennis" height="50" />
                </span>
              </div>
            </Link>
          </div>
          <div className="px-2">
            <h6 className="text-primary fw-medium">{title}</h6>
            <p className="text-muted">{subtitle}</p>

            {children}
          </div>
        </CardBody>
      </Card>
      <div className="mt-5 text-center">
        <p>© {new Date().getFullYear()} Clube do Tennis.</p>
      </div>
    </>
  )
}
